import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";

import { GOOGLE_ADS_DOWNLOAD_AUDIO_ID } from "@/constants/googleAds";
import { DOWNLOAD_AUDIO_TYPES } from "@/constants/posthog/downloadAudio";
import { trackAudioDownload } from "@/data/posthog/trackAudioDownload";
import { ConversionConstructedNoDates } from "@/types/types";
import { fireGoogleAdsConversion } from "@/utils/gtag/fireGoogleAdsConversion";
import { useIsClient } from "@/utils/hooks/useIsClient";
import { isHarmony } from "@/utils/typeGuards/isHarmony";

export function DownloadConversion({
  conversion,
}: {
  conversion: ConversionConstructedNoDates;
}) {
  const isClient = useIsClient();
  let tooltipContent;
  if (conversion.outputSoundWav === null) {
    tooltipContent = "Download MP3";
  } else {
    // 24-bit launched on 2025-05-24 14:30:00Z before this date we use 32-bit
    const twentyFourBitLaunchedDateTime = new Date("2025-05-24T14:30:00Z");
    const conversionCreatedAtDateTime = new Date(conversion.createdAtString);
    if (conversionCreatedAtDateTime > twentyFourBitLaunchedDateTime) {
      tooltipContent = "Download WAV (24-bit)";
    } else {
      tooltipContent = "Download WAV (32-bit)";
    }
  }

  const trackDownload = () => {
    const audioType =
      isHarmony(conversion) ?
        DOWNLOAD_AUDIO_TYPES.HARMONY
      : DOWNLOAD_AUDIO_TYPES.CONVERSION;
    trackAudioDownload({ audioType, entityId: conversion.id });
    fireGoogleAdsConversion({
      conversionLabel: GOOGLE_ADS_DOWNLOAD_AUDIO_ID,
      additionalData: null,
    });
  };

  return (
    <a
      data-testid={`conversion-id-output-${conversion.id}`}
      href={
        conversion.outputSoundWav === null ?
          conversion.outputSoundMp3!.presignedUrlDownload
        : conversion.outputSoundWav.presignedUrlDownload
      }
      download={
        conversion.outputSoundWav === null ?
          conversion.outputSoundMp3!.filename
        : conversion.outputSoundWav.filename
      }
      onClick={trackDownload}
    >
      <ArrowDownTrayIcon
        data-tooltip-id={`download-conversion-tooltip-${conversion.id}`}
        data-tooltip-content={isClient ? tooltipContent : undefined}
        data-tooltip-place="top"
        className="h-6 w-6 stroke-gray-900"
      />
      <Tooltip
        id={`download-conversion-tooltip-${conversion.id}`}
        className="z-10"
      />
    </a>
  );
}
